import React from 'react';
import PropTypes from 'prop-types';
import Header from '../../redux/containers/Header';
import Footer from '../Footer';
import BottomMenu from '../../redux/containers/BottomMenu';
import Container, { Content } from './styles';
import LargeScreenFooter from '../LargeScreenFooter';

const Layout = ({ children, isConnected }) => (
  <Container>
    <Header />
    <Content isConnected={isConnected} screenWidth={window.innerWidth}>
      {children}
    </Content>
    {window.innerWidth >= 992 ? <LargeScreenFooter /> : <Footer />}
    <BottomMenu />
  </Container>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  isConnected: PropTypes.bool.isRequired,
};

export default Layout;
